// extracted by css-extract-rspack-plugin
export default {"container":"SetupComplete_container__ckqgY"};